import { Button } from '@material-ui/core';
import { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import en from '../../../../lang/en-us';
import { OtpField, ResendOtp, useTimer } from '../../../../lib/OtpField';
import { RootStateType } from '../../../../redux-store/reducers';
import { OTP_ACTIONS } from '../../../../utils/constants';
import {
    verifyChangeEmailOTP as verifyOTP,
    sendPhoneOTP,
    sendEmailOTP,
    updateMultipleBanks,
} from '../../../../redux-store/actions/nct';
import OtpScreen from '../OtpScreen';
import { maskMobileNumber } from '../../../../utils/utilityFunctions';
import { ActionHeader } from '..';
import { SubmitButtonWithLoader } from '../../../../lib/Button';
import { common } from '@material-ui/core/colors';
import OtpSentTextWrapper from '../../../../lib/OtpSentTextWrapper';
import { ADD_BANK } from '.';
const { dashboard } = en;

const initState = {
    otp: null,
    reqId: null,
    otpRef: null,
};

function BankMandateOtp(props: any) {
    const { mobile = null, addBank = false } = props.location.state || {};
    const [otpInput, setOtp] = useState<any>(new Array(6).fill(''));
    const [count, setCount] = useState(0);
    const [{ otp, reqId, otpRef }, setOtpInfo] = useState(initState);
    const { timer, startTimer, resetTimer } = useTimer({});
    const [showModal, setShowModal] = useState<boolean>(false);
    const [loading, setLoading] = useState<boolean>(false);

    useEffect(() => {
        const { otp, reqId, otpRef, actionType } = props.location.state || {};
        if (!props?.imageInfo && actionType == ADD_BANK) {
            props.history.push('/');
            return;
        }
        setOtpInfo({
            otp,
            reqId,
            otpRef,
        });
    }, []);

    const handleSubmit = async () => {
        setLoading(true);
        try {
            const { pan, pekrn, mobile } = props;
            const { targetFunds, actionType } = props.location.state;
            const payload = {
                enteredOtp: otpInput.join(''),
                otpRef,
                reqId,
                mobile,
                pan,
                pekrn,
                action: OTP_ACTIONS.updateMultipleBanks,
            };

            await props.verifyOTP(payload);
            if (addBank) {
                await updateMulitpleBankDetails();
                return;
            }
            props.history.replace('bank-mandate-delete-selected', {
                targetFunds,
                actionType,
                reqId,
            });
        } catch (err: any) {
            alert(err.message);
        } finally {
            setLoading(false);
        }
    };

    const updateMulitpleBankDetails = async () => {
        try {
            const { data, amc, operationType } = props.location.state;
            const images = props?.imageInfo?.type === 'BANK_MANDATE' ? props?.imageInfo?.data : [];
            if (!images.length) {
                alert(en.networkText.unableToProcess);
                return;
            }
            const { pan, pekrn, mobile: existingMobile } = props;
            let res = await props.updateMultipleBanks({
                data,
                pan,
                pekrn,
                reqId,
                operationType,
                images,
                mobile: existingMobile,
            });
            props.history.replace('bank-mandate-success', {
                data: data,
                mobile: mobile,
                ...(res || {}).body,
            });
        } catch (err: any) {
            alert(err.message);
        }
    };

    const onResend = async () => {
        try {
            const { pan = '', pekrn = '', mobile: existingMobile, email } = props;
            let payload = {
                mobile,
                pan,
                pekrn,
                action: OTP_ACTIONS.updateMultipleBanks,
            };

            let res = await props.sendPhoneOTP(payload);
            setShowModal(true);
            setOtpInfo({ ...(res || {}).body });
            setOtp(new Array(6).fill(''));
            resetTimer();
        } catch (err: any) {
            alert(err.message);
        }
    };

    return (
        <div className="curved-bg">
            <ActionHeader header={dashboard.BankMandate.BankMandateHeading} />
            <div className="curved-bg-content">
                <img className="change-email-img" src="/images/change-email-img.png" alt="" />
                <div className="curved-bg-content-inner">
                    <div className="curved-bg-content-inner-top">
                        <h3 className="subheading">
                            {dashboard.OtpScreen.subHeading}
                            <span>{dashboard.OtpScreen.subHeadingSpan}</span>
                        </h3>
                        <OtpSentTextWrapper
                            userRegisteredWith={props.userRegisteredWith}
                            mobile={maskMobileNumber(mobile)}
                            email={props.email}
                        />
                        <OtpField
                            value={otpInput}
                            updateValue={(otp: string[]) => {
                                setCount(count + 1);
                                setOtp(otp);
                            }}
                            showModal={showModal}
                            _handleProceed={() => setShowModal(false)}
                        />
                    </div>
                    <div className="curved-bg-content-inner-bottom">
                        <SubmitButtonWithLoader
                            disabled={otpInput.join('').length !== 6}
                            loading={loading}
                            label={dashboard.OtpScreen.buttonText}
                            labelWhileLoading={dashboard.OtpScreen.buttonTextWhileLoading}
                            onClick={handleSubmit}
                        />
                        <ResendOtp counter={timer} onResendOtp={onResend} startTimer={startTimer} />
                    </div>
                </div>
            </div>
        </div>
    );
}

export default connect(
    ({ authReducer, portfolio }: RootStateType) => ({ ...authReducer, ...portfolio }),
    {
        verifyOTP,
        sendPhoneOTP,
        sendEmailOTP,
        updateMultipleBanks,
    },
)(BankMandateOtp);
